import { CalendarIcon } from 'lucide-react'

type CalendarButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>

export function CalendarButton (props: CalendarButtonProps) {
  return (
    <button
      {...props}
      aria-label='Show date picker'
      className='appearance-none rounded-sm p-1 cursor-pointer text-gray-500 hover:text-gray-700 active:text-gray-800 outline-none focus-visible:ring ring-transparent focus-visible:ring-thatch-500 transition-all'
      type='button'
    >
      <CalendarIcon aria-hidden size={16} />
    </button>
  )
}
